module.exports = __webpack_public_path__ + "img/0Q3A9771_L_WoodMatted.f6cce8c3.jpg";